import { UserActionPlan } from "@/data/interfaces/UserActionPlan";
import api from "./api";

const userActionPlanService = {
  getMyActionPlans: async () => {
    const resp = await api.get("/user/action-plans-progress");
    return resp.data.data as UserActionPlan[];
  },

  updateProgress: async (id: number, percent: number) => {
    const resp = await api.put(`/doctor/user-action-plans/${id}`, {
      percent,
    });
    return resp.data.data as UserActionPlan;
  },
};



export default userActionPlanService;
